// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3OpOP","screens-container":"styles_screens-container__1-E1Q","screensContainer":"styles_screens-container__1-E1Q"};